import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './Copy.module.scss'
import { useState } from 'react'
import { ReactComponent as CopyToClipboardIcon } from 'images/common/copy-to-clipboard.svg'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const cx = classNames.bind(styles)

const Copy = ({ textToCopy, tooltipText }) => {
  const { t } = useTranslation(['translations'])

  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!textToCopy) return
    await navigator.clipboard.writeText(textToCopy)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  const overlay = (
    <Tooltip className={cx('tooltip')}>
      <div className={cx('tooltip-content')}>{copied ? `${t('commonComponents.copy.copied')}` : `${t('commonComponents.copy.copy')} ${tooltipText}`}</div>
    </Tooltip>
  )

  return (
    <div className={cx("copy")} onClick={handleCopy}>
      <OverlayTrigger placement="top" overlay={overlay}>
        <CopyToClipboardIcon />
      </OverlayTrigger>
    </div>
  )
}

Copy.propTypes = {
  textToCopy: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
}

Copy.defaultProps = {
  tooltipText: ''
}

export { Copy }